import { z } from 'zod';
import { UploadIdSchema } from '../constants/upload-id.js';

export const ReportRequestedPayload = z.object({
  reportId: z.string().cuid2(),
  tenantId: z.string().cuid2(),
});

export type ReportRequestedPayload = z.infer<typeof ReportRequestedPayload>;

export const ScoreAssetPayload = z.object({
  reportId: z.string().cuid2(),
  reportAssetId: z.string().cuid2(),
  tenantId: z.string().cuid2(),
});

export type ScoreAssetPayload = z.infer<typeof ScoreAssetPayload>;

export const UploadConfirmedPayload = z.object({
  uploadId: UploadIdSchema,
  tenantId: z.string().cuid2(),
});

export type UploadConfirmedPayload = z.infer<typeof UploadConfirmedPayload>;
